import { Dropdown, Tooltip } from 'antd'
import { useTranslation } from 'contexts/Localization'
import { useRemoveAddToCart } from 'hooks/useCart'
import { useFormatCurrency } from 'hooks/useFormatCurrency'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setAddToCartAnimation } from 'state/cart/actions'
import styled from 'styled-components'
import { Link } from 'widgets'
import Cart from 'widgets/Svg/Icons/Cart'

const WrappMenuCart = styled.div`
  margin: 0 0 0 24px;

  &.is-scroll {
    .box-icon {
      svg {
        path {
          &:nth-child(1) {
            fill: #000;
          }
        }
      }
    }
  }

  .box-icon {
    position: relative;
    cursor: pointer;

    svg {
      path {
        transition: 0.2s;
      }
    }

    &:hover,
    &.hover {
      svg {
        path {
          transition: 0.2s;

          &:nth-child(1),
          &:nth-child(2) {
            fill: #006dfe;
          }
        }
      }
    }
  }

  &:not(.is-scroll) {
    .box-icon {
      svg {
        &:nth-child(2) {
          position: absolute;
          left: 0;
          top: 0;
          filter: blur(5px);
          opacity: 0;
          z-index: -1;
          transition: 0.2s;

          path {
            &:nth-child(1),
            &:nth-child(2) {
              fill: #fff;
            }
          }
        }
      }

      &:hover,
      &.hover {
        svg {
          &:nth-child(2) {
            opacity: 1;
          }
        }

        path {
          &:nth-child(1) {
            fill: #fff;
          }
        }
      }
    }
  }

  @media (max-width: 1024px) {
    margin: 0;
  }
`

const CustomeMenuCartEmpty = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 1px 0px 10px rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  border-radius: 10px;
  width: 333px;
  min-height: 179px;
  max-height: 335px;

  .content-cart {
    text-align: center;

    img {
      margin-bottom: 15px;
    }

    p {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 15px;
      text-align: center;
      color: #006dfe;
    }
  }
`

const CustomeMenuCart = styled.div`
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 1px 0px 10px rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  border-radius: 10px;
  width: 333px;
  padding: 12px 16px;
  overflow: auto;

  .content-cart {
    min-height: 179px;
    max-height: 70vh;

    .cart-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;

      img {
        width: 15px;
        cursor: pointer;

        &:not(:last-child) {
          margin-right: 10px;
        }
      }

      p {
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 20px;
        color: #000000;
      }
    }

    .cart-body {
      maring-bottom: 14px;
      padding-bottom: 20px;
      border-bottom: 1px solid #6d6d6d;

      .cart-body-item {
        display: flex;
        align-items: center;
        justify-content: space-between;

        &:not(:last-child) {
          margin-bottom: 5px;
        }

        .cart-body-item-left {
          display: flex;
          align-items: center;

          img,
          video {
            width: 40px;
            height: 40px;
            object-fit: cover;
            margin-right: 10px;
          }

          p {
            font-style: normal;
            font-weight: 700;
            font-size: 14px;
            line-height: 18px;
            color: #000000;
          }
        }

        .cart-body-item-right {
          display: flex;
          align-items: center;

          .cart-body-item-price {
            display: flex;
            align-items: baseline;
            text-align: right;
            margin-right: 7px;
            font-weight: bold;
            img {
              display: inline-block;
              width: 13px;
              transform: translateY(2px);
              margin-left: 6px;
            }

            p {
              &:nth-child(1) {
                width: max-content;
              }
              &:nth-child(2) {
                font-size: 9px;
                font-weight: 400;
              }
            }
          }

          .icon-delete {
            width: 13px;
          }

          button {
            border: none;
            background: transparent;
            cursor: pointer;
          }
        }
      }
    }

    .cart-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 14px;
      padding-bottom: 15px;

      button {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;
        width: 150px;
        height: 30px;
        text-align: center;
        text-transform: capitalize;
        color: #ffffff;
        background: #006dfe;
        border-radius: 20px;
        border: none;
        cursor: pointer;
      }

      p {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 19px;
        text-align: right;
        color: #006dfe;
      }
    }
  }
`

const AnimationAddToCart = styled.div<{
  positionX: number
  positionY: number
  positionCurrentX: number
  positionCurrentY: number
  action: boolean
}>`
  position: fixed;
  top: ${({ positionCurrentY }) => `${positionCurrentY}px`};
  left: ${({ positionCurrentX }) => `${positionCurrentX}px`};
  width: 230px;
  height: 330px;
  opacity: 0;
  animation: ${({ action }) => `${action ? '0.7s animation-cart' : ''}`};
  animation-delay: 0.3s;
  pointer-events: none;

  img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  video {
    position: relative;
    left: 0;
    top: 0;
    z-index: 1;
  }

  @keyframes animation-cart {
    0% {
      top: ${({ positionCurrentY }) => `${positionCurrentY}px`};
      left: ${({ positionCurrentX }) => `${positionCurrentX}px`};
      width: 230px;
      height: 330px;
      opacity: 1;
    }
    100% {
      top: ${({ positionY }) => `${positionY}px`};
      left: ${({ positionX }) => `${positionX}px`};
      width: 20px;
      height: 20px;
      opacity: 0.2;
    }
  }
`

const menuCartEmpty = (t) => (
  <CustomeMenuCartEmpty>
    <div className="content-cart">
      <img src="/images/header/cart-empty.png" alt="" />
      <p>{t('Your shopping cart is empty!')}</p>
    </div>
  </CustomeMenuCartEmpty>
)

const menuCart = (cartNFT, currencyRate, hanldeRemoveAddToCart, calcPrice, getFormatCurrencyToCommas) => (
  <CustomeMenuCart>
    <div className="content-cart">
      <div className="cart-header">
        <p>Recently Added Products</p>

        <div className="action-cart">
          <img src="/images/cart/reload-black.svg" alt="" />

          <img src="/images/cart/icon-delete-black.svg" alt="" />
        </div>
      </div>

      <div className="cart-body">
        {cartNFT?.map((item) => (
          <div className="cart-body-item" key={item?.nft?.id}>
            <div className="cart-body-item-left">
              {item?.nft?.moreInfo?.itemType === 'video/mp4' ? (
                <video width="100%" height="100%" autoPlay muted loop playsInline>
                  <source src={item?.nft?.animationUrl} type="video/mp4" />
                </video>
              ) : (
                <img src={item?.nft?.image || item?.nft?.animationUrl} alt={item?.nft?.name} />
              )}
              <p>
                {item?.nft?.name?.length < 15 ? (
                  item?.nft?.name
                ) : (
                  <Tooltip
                    placement="top"
                    color="#ffffff"
                    title={<p className="tooltip-content-dark">{item?.nft?.name}</p>}
                  >
                    {item?.nft?.name.slice(0, 15)}...
                  </Tooltip>
                )}
              </p>
            </div>

            <div className="cart-body-item-right">
              <div className="cart-body-item-price">
                <div>
                  <p>{item.salePrice} USDT</p>
                  <p>~{getFormatCurrencyToCommas(+item.salePrice * +currencyRate?.['binance-usd']?.usd)}</p>
                </div>

                <img src="/images/coins/usdt.svg" alt="" />
              </div>

              <button type="button" onClick={() => hanldeRemoveAddToCart(item)}>
                <img className="icon-delete" src="/images/cart/icon-delete.svg" alt="" />
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="cart-footer">
        <Link href="/cart">
          <button type="button">View Cart</button>
        </Link>
        <p>~{getFormatCurrencyToCommas(+calcPrice(cartNFT) * +currencyRate?.['binance-usd']?.usd)}</p>
      </div>
    </div>
  </CustomeMenuCart>
)

const MenuCart = ({ isScroll, refContainerDropdown }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { cartNFT, addToCartAnimation } = useSelector((state: any) => state.cart)
  const { currencyRate } = useSelector((state: any) => state.balances)
  const refCart = useRef(null)

  const [positionCart, setPositionCart] = useState({
    x: 0,
    y: 0,
  })

  useEffect(() => {
    if (refCart.current) {
      const { x, y } = refCart.current.getBoundingClientRect()
      setPositionCart({
        x,
        y,
      })
    }
  }, [])

  const [visibleDropdown, setVisibleDropdown] = useState(false)

  const [removeAddToCart] = useRemoveAddToCart()
  const [getFormatCurrency, getFormatCurrencyToCommas] = useFormatCurrency()

  const handleVisibleChange = (flag: boolean) => {
    setVisibleDropdown(flag)
  }

  const hanldeRemoveAddToCart = (product) => {
    removeAddToCart(product)
  }

  const calcPrice = (item) => {
    return item.reduce((accumulator, object) => {
      return +accumulator + +object.salePrice
    }, 0)
  }

  useEffect(() => {
    if (addToCartAnimation.action) {
      setTimeout(() => {
        dispatch(
          setAddToCartAnimation({
            x: 0,
            y: 0,
            action: false,
          }),
        )
      }, 950)
    }
  }, [addToCartAnimation.action, dispatch])

  return (
    <>
      <WrappMenuCart className={isScroll ? 'is-scroll' : ''}>
        <AnimationAddToCart
          positionX={positionCart.x}
          positionY={positionCart.y}
          positionCurrentY={addToCartAnimation.y + 25}
          positionCurrentX={addToCartAnimation.x + 55}
          action={addToCartAnimation.action}
        >
          {addToCartAnimation.type === 'image' ? (
            <img src={addToCartAnimation.url} alt="" />
          ) : (
            <>
              <img src="/images/nft/nft-default.png" alt="" />
              <video width="100%" height="100%" autoPlay muted loop playsInline>
                <source src={addToCartAnimation.url} type="video/mp4" />
              </video>
            </>
          )}
        </AnimationAddToCart>

        <Dropdown
          overlay={
            cartNFT.length === 0
              ? menuCartEmpty(t)
              : menuCart(cartNFT, currencyRate, hanldeRemoveAddToCart, calcPrice, getFormatCurrencyToCommas)
          }
          placement="bottom"
          trigger={['hover']}
          open={visibleDropdown}
          onOpenChange={handleVisibleChange}
          getPopupContainer={() => refContainerDropdown.current}
        >
          <div ref={refCart} className={`box-icon ${visibleDropdown ? 'hover' : ''}`}>
            <Link href="/cart">
              <Cart />
              {!isScroll && <Cart />}
            </Link>
          </div>
        </Dropdown>
      </WrappMenuCart>
    </>
  )
}

export default MenuCart
